"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStaticContent = void 0;
const next12_utils_request_1 = __importDefault(require("@gcloud-npm/next12.utils.request"));
const next12_utils_sonda_1 = __importDefault(require("@gcloud-npm/next12.utils.sonda"));
const next12_utils_build_environments_1 = require("@gcloud-npm/next12.utils.build-environments");
const next12_utils_environment_1 = require("@gcloud-npm/next12.utils.environment");
const next12_utils_monitoring_1 = require("@gcloud-npm/next12.utils.monitoring");
const familyApi = "bucket";
const processName = "ADABYRON-API";
const getStaticContent = ({ preRenderEnv = "", build = true, resourcePath, context, idFront, }) => {
    const idRequest = (0, next12_utils_monitoring_1.getUUID)(idFront);
    const sonda = new next12_utils_sonda_1.default({
        eventName: "MISC.GET_STATIC_CONTENT",
        context,
        uniqueId: idRequest,
        origin: processName,
    });
    if (!resourcePath) {
        return new Promise.reject("Resource path should exists");
    }
    if (preRenderEnv) {
        const environments = (0, next12_utils_environment_1.findOutEnvByHost)(preRenderEnv);
        context.environment = environments;
    }
    const { bucket: connectionData } = context.environment;
    const { endpoint: host } = connectionData;
    const URL_API = `${host}${resourcePath}`;
    const headers2Use = (0, next12_utils_build_environments_1.calculateHeaderParams)(build, familyApi, context);
    const request = new next12_utils_request_1.default({
        method: "GET",
        endpoint: URL_API,
        headers: Object.assign({}, headers2Use),
        sonda,
    });
    return request.makeRequest();
};
exports.getStaticContent = getStaticContent;
exports.default = exports.getStaticContent;
//# sourceMappingURL=index.js.map